import { createSelector } from 'reselect';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [accountAllIds, accountsById, allAccountsSelector] =
  resourceSelectors('accounts');

export const accountByIdSelector = (id) =>
  createSelector(accountsById, (byId) => byId[id]);
